<template>
  <span>
    {{ currentValue }}
  </span>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "AnimatedNumber",
  components: {},
  props: {
    start: {
      type: [Number, String],
      default: 0,
    },
    number: {
      type: [Number, String],
      default: 100,
    },
    delay: {
      type: [Number, String],
      default: 500,
    },
    duration: {
      type: [Number, String],
      default: 3000,
    },
  },
  data() {
    return {
      currentValue: 0,
    };
  },
  mounted() {
    setTimeout(this.startAnimation, parseInt(`${this.delay}`) || 500);
  },
  methods: {
    startAnimation() {
      const start = parseInt(`${this.start}`) || 0;
      const number = parseInt(`${this.number}`) || 100;
      const duration = parseInt(`${this.duration}`) || 3000;
      this.animateValue(
        start,
        number,
        duration,
        (val) => (this.currentValue = val)
      );
    },
    animateValue(start, end, duration, setValue) {
      let startTimestamp = null;
      const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        const newValue = Math.floor(progress * (end - start) + start);
        setValue(newValue);
        if (progress < 1) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    },
  },
});
</script>

<style>
.svg-heart {
  clip-path: url(#myClip);
}
</style>
